import React from 'react';
import Base from '../core/Base'
const UserDashboard = () => {
    return ( 
        <Base title="UserDashboard page">
            <h1>This is UserDashboard page</h1>
        </Base>
     );
}
 
export default UserDashboard;